export default __webpack_public_path__ + "static/media/Level=0.82a0298c.svg";